import { render, staticRenderFns } from "./Despachos.vue?vue&type=template&id=0db905a0"
import script from "./Despachos.vue?vue&type=script&lang=js"
export * from "./Despachos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports